angular.module('modals')
    .controller('ChangeEmailModalController', ['$scope', '$q', '$uibModalInstance', '$uibModal', 'Logger', 'Alert', 'ModalHandler', 'ProviderInvitation', 'Registration', 'User', 'user',
        function($scope, $q, $uibModalInstance, $uibModal, Logger, Alert, ModalHandler, ProviderInvitation, Registration, User, user) {
            $scope.user_id = user.id;
            $scope.oldEmail = user.email;
            $scope.newEmail = '';

            $scope.checkEmail = function (email) {
                if (!email) {
                    return $q.reject();
                }

                var deferred = $q.defer();

                // Run invitation and user lookups in parallel and treat any match as a conflict
                var invitationCheck = ProviderInvitation
                    .findByEmail({ email: email })
                    .$promise
                    .then(function (invitations) { return Array.isArray(invitations) && invitations.length > 0; }, function () { return true; });

                var userCheck = User
                    .findByEmail({ email: email, user_type: 'regular' }) // ignores guest users
                    .$promise
                    .then(function (users) { return Array.isArray(users) && users.length > 0; }, function () { return true; });

                $q.all([invitationCheck, userCheck]).then(function (results) {
                    var conflictFound = results[0] || results[1];
                    if (conflictFound) {
                        $scope.form.newEmail.$setValidity('email', false);
                        $scope.alerts = [];
                        Alert.error($scope.alerts, 'user.exists', true);
                        deferred.reject();
                    } else {
                        $scope.form.newEmail.$setValidity('email', true);
                        $scope.alerts = [];
                        deferred.resolve();
                    }
                });

                return deferred.promise;
            };

            $scope.submit = function () {
                Registration.requestEmailChange({
                    user_id: $scope.user_id,
                    email: $scope.newEmail
                }).$promise
                    .then(function() {
                        ModalHandler.dismiss($uibModalInstance);

                        // show dialog confirming that request was submitted
                        var modalInstance = $uibModal.open({
                            templateUrl: 'partials/user/change_email_request_confirmation.html',
                            controller: 'ChangeEmailRequestConfirmationController',
                            resolve: {
                                newEmail: function() {
                                    return $scope.newEmail;
                                }
                            }
                        });
                        ModalHandler.set(modalInstance);
                        modalInstance.result
                            .then(function () {
                                // Logger.log('Confirmation dialog dismissed');
                            })
                            .catch(function () {
                                // Logger.log('Confirmation dialog cancelled');
                            });                        
                    })
                    .catch(function(response) {
                        // 403: the caller may not edit this user (DCL-618).
                        // user.exists: another account took the address after
                        // checkEmail passed, or the check failed open (DCL-666).
                        var errors = response && response.data && response.data.errors;
                        var messages = (errors && errors.message) || [];
                        $scope.alerts = [];
                        if (messages.indexOf('user.exists') !== -1) {
                            Alert.error($scope.alerts, 'user.exists', true);
                        } else {
                            Alert.error($scope.alerts, response && response.status === 403 ? 'email.change.forbidden' : 'email.change.failed', true);
                        }
                    });
            };

            $scope.discard = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ])
    .controller('ChangeEmailRequestConfirmationController', ['$scope', '$uibModalInstance', 'ModalHandler', 'newEmail',
        function($scope, $uibModalInstance, ModalHandler, newEmail) {
            $scope.newEmail = newEmail;
            
            $scope.close = function() {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ])
    .controller('ResetPasswordModalController', ['$scope', '$uibModalInstance', '$uibModal', 'Logger', 'ModalHandler', 'Notification', 'Password', 'user',
        function($scope, $uibModalInstance, $uibModal, Logger, ModalHandler, Notification, Password, user) {
            $scope.email = user.email;

            $scope.submit = function () {
                Password.reset({'user': {'email': $scope.email}}).$promise
                    .then(function() {
                        ModalHandler.dismiss($uibModalInstance);

                        // show dialog confirming that request was submitted
                        var modalInstance = $uibModal.open({
                            templateUrl: 'partials/user/reset_password_request_confirmation.html',
                            controller: 'ResetPasswordConfirmationController',
                            resolve: {
                                email: function() {
                                    return $scope.email;
                                }
                            }
                        });
                        ModalHandler.set(modalInstance);
                        modalInstance.result
                            .then(function () {
                                // Logger.log('Confirmation dialog dismissed');
                            })
                            .catch(function () {
                                // Logger.log('Confirmation dialog cancelled');
                            });                        
                    })
                    .catch(function(response) {
                        Notification.error((response.data && response.data.error) ||
                            'Unable to send the password reset email. Please try again.');
                    });
            };

            $scope.discard = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ])
    .controller('ResetPasswordConfirmationController', ['$scope', '$uibModalInstance', 'ModalHandler', 'email',
        function($scope, $uibModalInstance, ModalHandler, email) {
            $scope.email = email;
            
            $scope.close = function() {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ])
    .controller('CreateLoginModalController', ['$scope', '$uibModalInstance', '$uibModal', 'Logger', 'Alert', 'ModalHandler', 'User', 'user',
        function($scope, $uibModalInstance, $uibModal, Logger, Alert, ModalHandler, User, user) {
            $scope.email = "";

            $scope.submit = function () {
                User.sendPasswordInvitation({ id: user.id }, { email: $scope.email}).$promise
                    .then(function() {
                        $uibModalInstance.close($scope.email);

                        // show dialog confirming that request was submitted
                        var modalInstance = $uibModal.open({
                            templateUrl: 'partials/user/create_login_request_confirmation.html',
                            controller: 'CreateLoginConfirmationController',
                            resolve: {
                                email: function() {
                                    return $scope.email;
                                }
                            }
                        });
                        ModalHandler.set(modalInstance);
                        modalInstance.result
                            .then(function () {
                            })
                            .catch(function () {
                                // Logger.log('Confirmation dialog dismissed');
                            });                        
                    })
                    .catch(function(response) {
                        // DCL-666: the server refuses an address another
                        // account holds; keep the dialog open to fix it.
                        var errors = response && response.data && response.data.errors;
                        var messages = (errors && errors.message) || [];
                        $scope.alerts = [];
                        Alert.error($scope.alerts, messages.indexOf('user.exists') !== -1 ? 'user.exists' : 'default.error', true);
                    });
            };

            $scope.discard = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ])
    .controller('CreateLoginConfirmationController', ['$scope', '$uibModalInstance', 'ModalHandler', 'email',
        function($scope, $uibModalInstance, ModalHandler, email) {
            $scope.email = email;
            
            $scope.close = function() {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ]);
